import {IFormFilesInterface} from "../Shared/form-files.interface";

export type IFreeportFormFifthSectionInterface = {
    AdditionalDocuments?: Array<IFormFilesInterface>,
}

export const FreeportFormFifthSectionInterface = (): IFreeportFormFifthSectionInterface => ({
    AdditionalDocuments: undefined
})